/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import jwt_decode from "jwt-decode";
import authActions from '../../redux/features/auth/actions';
import useAuthorizedEpApps from '../../hooks/useAuthorizedEpApps';
import config from '../../config/config';
import { PERFORMANCE_INSIGHTS_APP_NAME } from '../../constants';
// import TabbedView from '../../atomicComponents/TabbedView/TabbedView';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import FileUploadComp from '../../components/FileUploadComp/FileUploadComp';
import TableView from '../../components/FileUploadComp/TableView/TableView';
import TemploadUpload from '../../components/FileUploadComp/TemplateUpload/TemplateUpload';
import TabSwitcher from '../../components/FileUploadComp/TabSwitcher/TabSwitcher';
import styles from './FileUploadLogs.module.css';
import { saveLogToBackend } from '../../api';
import FileuploadLogsComp from '../../components/FileUploadComp/FileUploadLogs/FileuploadLogsComp';

const { API_BASE_URL } = config;

const FileUploadLogs = ({
  isAuthenticated,
  authPolicies,
  currentUserId,
}) => {

  const authorizedApps = useAuthorizedEpApps(isAuthenticated, authPolicies);
  const { showLoading } = usePopupManager();

  useEffect(() => {
    if (
      authorizedApps.length &&
      !authorizedApps.includes(PERFORMANCE_INSIGHTS_APP_NAME)
    ) {
      showLoading();
      window.location.replace(config.HOME_UI_BASE_URL);
    }
  }, [authorizedApps, currentUserId]);

  return (
    <div className={styles.container}>
      <FileuploadLogsComp />
    </div>
  )
}

FileUploadLogs.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  authPolicies: PropTypes.object.isRequired,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default connect(({ auth, userProfile }) => ({
  isAuthenticated: auth.isAuthenticated,
  authPolicies: auth.authPolicies,
  currentUserId: userProfile.userId,
  setAuthToken: authActions.setAuthToken,
}))(FileUploadLogs);
